var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import getSymbolFromCurrency from 'currency-symbol-map';
import localforage from 'localforage';
import React, { useEffect, useState } from 'react';
import { cross } from '../../../../images/icon';
import { publishReviewPurchasePopup } from '../../Events/monetisation.events';
import { parseJSON } from '../../utils/parseJSON';
var ReviewPurchase = function (_a) {
    var _b, _c, _d;
    var metadataMap = _a.metadataMap, taxDetails = _a.taxDetails, layoutSettings = _a.layoutSettings;
    var _e = __read(useState(null), 2), recurringType = _e[0], setRecurringType = _e[1];
    var _f = __read(useState('not identified'), 2), cycleType = _f[0], setCycleType = _f[1];
    var currentPlan = parseJSON(sessionStorage.getItem('currentPlan'));
    var getLocalizedCycleType = function (type) {
        if (type === 'yr') {
            return (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.yearlyText) || "Yearly";
        }
        else if (type === 'mo') {
            return (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.monthlyText) || "Monthly";
        }
        else if (type == "Rent") {
            return "Rent";
        }
        return "Buy";
    };
    var handleTransactionalDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ((currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.type) === "Svod") {
                setCycleType((currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.cycleType) ? getLocalizedCycleType(currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.cycleType) : 'not identified');
                setRecurringType((metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.recurringText) || "Recurring");
            }
            else {
                setCycleType('One time');
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        handleTransactionalDetails();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "review-purchase-container" },
            React.createElement("div", { style: { backgroundColor: layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.moduleBackgroundColor }, className: "review-purchase-wrapper" },
                React.createElement("h4", { className: 'site-color' }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.reviewPurchaseTxt) || 'Review Purchase'),
                React.createElement("div", { className: 'cross-icon', onClick: function () { return publishReviewPurchasePopup("cancelled"); } }, cross("#fff")),
                currentPlan && taxDetails && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'review-container' },
                        React.createElement("div", { className: 'review-detail' },
                            React.createElement("h5", null, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.paymentMethodTxt) || "Payment Method"),
                            React.createElement("h5", null, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.cardText) || "Card")),
                        React.createElement("div", { className: 'review-detail' },
                            React.createElement("h5", null, 'Billing Frequency'),
                            React.createElement("h5", null, cycleType)),
                        recurringType &&
                            React.createElement("div", { className: 'review-detail' },
                                React.createElement("h5", null, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.purchaseTypeTxt) || "Purchase Type"),
                                React.createElement("h5", null, recurringType)),
                        React.createElement("div", { className: 'review-detail' },
                            React.createElement("h5", null, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.chargeTxt) || 'Charge'),
                            React.createElement("h5", null,
                                (taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.pretaxAmount) === 0 || (taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.pretaxAmount) ? "".concat(getSymbolFromCurrency((_b = currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.plansDetail) === null || _b === void 0 ? void 0 : _b.recurringPaymentCurrencyCode), " ").concat(taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.pretaxAmount) : taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.amount,
                                (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.type) === 'Svod' ? "/".concat(cycleType) : '')),
                        true || (taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.taxAmount) ? React.createElement("div", { className: 'review-detail' },
                            React.createElement("h5", null, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.tax) || 'Tax'),
                            React.createElement("h5", null, "".concat(getSymbolFromCurrency((_c = currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.plansDetail) === null || _c === void 0 ? void 0 : _c.recurringPaymentCurrencyCode), " ").concat(taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.taxAmount))) : React.createElement(React.Fragment, null)),
                    (taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.amount) === 0 || (taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.amount) ? React.createElement("div", { className: 'review-detail' },
                        React.createElement("h5", null, metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.total),
                        React.createElement("h5", null, "".concat(getSymbolFromCurrency((_d = currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.plansDetail) === null || _d === void 0 ? void 0 : _d.recurringPaymentCurrencyCode), " ").concat(taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.amount))) : React.createElement(React.Fragment, null)),
                React.createElement("input", { "aria-labelledby": (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.confirmTxt) || 'Confirm Purchase', className: 'button continue-button site-cta-color site-cta-background-color', onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var checkoutStore;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, localforage.getItem('CheckoutStore')];
                                case 1:
                                    checkoutStore = _a.sent();
                                    // console.log("payment details", checkoutStore)
                                    publishReviewPurchasePopup(null);
                                    return [2 /*return*/];
                            }
                        });
                    }); }, type: "button", value: (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.confirmTxt) || 'Confirm Purchase' })))));
};
export default ReviewPurchase;
